import { queryKeyFactory } from "@l2r-front/l2r-query"

export const NETWORK_CONDITIONS_ROOT_QUERY_KEY = "networkConditions"

export const networkConditionsQueryKeys = queryKeyFactory(NETWORK_CONDITIONS_ROOT_QUERY_KEY, {
})
